@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;

.panel {
  position: relative;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.2s linear;
  padding: 16px 0;

  @include c.containerMedia(v.$js-defined-mobile-breakpoint) {
    width: 100%;
    padding-top: 80px;
    padding-bottom: 88px;
  }

  &.isLoading {
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.elementsWrapper {
  padding: 0 16px;
  margin-bottom: 4px;
}

.backButtonWrapper, .toolsContentWrapper {
  margin-bottom: 8px;
}

.toolsWrapper {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 8px 16px;
  background-color: v.$palette-white;
  border-radius: 16px;
  box-shadow: v.$shadow-2;
}

.toolsContent {
  display: flex;
  align-items: center;
  padding: 0 16px;
  background-color: v.$palette-white;
  border-radius: 16px;
  box-shadow: v.$shadow-2;
}

.panelViews {
  flex-grow: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  @include c.custom-scrollbar();
  @include c.hide-scrollbar;

  &.marginTop {
    margin-top: 8px;
  }
}

.statusFilterWrapper {
  margin: 4px 0;
  padding: 0 16px;
}

.uploadFileBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: v.$palette-gray-200;
  border-radius: 6px;
  width: 48px;
  height: 32px;
}

.uploadFileOpener {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.uploadFileOpenerTooltipText, .deleteAllButtonTooltipText, .updateAllButtonTooltipText {
  background-color: v.$palette-gray-900-raw;
  position: relative;
  color: v.$palette-pure-white;
  padding: 8px 16px;
  border-radius: 6px;
  z-index: v.$z-index-upload-file-opener-tooltip-text;
  @include t.text(14px, 22px, 400);

  &::after {
    content: "";
    left: calc(50% - 7px);
    bottom: -7px;
    position: absolute;
    background-color: v.$palette-gray-900-raw;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    rotate: 135deg;
  }
}

:global([data-theme="dark"]) {
  .uploadFileOpenerTooltipText,
  .deleteAllButtonTooltipText,
  .updateAllButtonTooltipText {
    background-color: v.$palette-gray-300;
    color: v.$palette-pure-white;

    &::after {
      background-color: v.$palette-gray-300;
    }
  }
}

.buttonsWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 152px;
  margin-left: auto;
  margin-bottom: auto;
  padding: 8px 0;

  li:first-child {
    margin-left: auto;
  }

  li:not(:first-child) {
    margin-left: 8px;
  }
}

.isBackButtonVisible {
  top: 256px;
}
